const orderTypeMessages = {
    WHATSAP: "WhatsApp",
    EN_MESA: "En Mesa",
    DELIVERY: "Delivery",
    A_DISTANCIA: "A Distancia",
    MOSTRADOR: "Mostrador"
};

export default orderTypeMessages;
